import { IconCompass } from '@tabler/icons-react'

import {
  ResponsiveDialogBody,
  ResponsiveDialogDescription,
  ResponsiveDialogDismiss,
  ResponsiveDialogFooter,
  ResponsiveDialogHero,
  ResponsiveDialogTitle,
} from '@/components/common/responsive-dialog'
import { Button } from '@/components/sui/button'
import { useComponentTranslation } from '@/hooks/use-component-translation'

import locales from '../locales'

interface WelcomeStepProps {
  onStart: () => void
}

export function WelcomeStep({ onStart }: WelcomeStepProps) {
  const { t } = useComponentTranslation(locales)

  return (
    <>
      <ResponsiveDialogBody layout="centered">
        <ResponsiveDialogHero
          icon={
            <div className="bg-primary/10 flex h-12 w-12 items-center justify-center rounded-xl">
              <IconCompass className="text-link h-6 w-6" />
            </div>
          }
        >
          <ResponsiveDialogTitle className="text-2xl">
            {t('title')}
          </ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            {t('description')}
          </ResponsiveDialogDescription>
        </ResponsiveDialogHero>
      </ResponsiveDialogBody>

      <ResponsiveDialogFooter>
        <ResponsiveDialogDismiss intent="close" />
        <Button onClick={onStart}>{t('actions.start')}</Button>
      </ResponsiveDialogFooter>
    </>
  )
}
